// AuthConfirm.tsx
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import supabase from '../../../ofindo/database/supabaseClient'

export function AuthConfirm() {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const token_hash = searchParams.get('token_hash')
    const type = searchParams.get('type') as 'recovery' | null
    const redirect_to = searchParams.get('redirect_to') || '/'

    const verifyOtp = async () => {
      if (token_hash && type === 'recovery') {
        const { error } = await supabase.auth.verifyOtp({
          type: 'recovery',
          token_hash,
        })

        if (!error) {
          navigate(redirect_to, { replace: true })
          return
        }
      } else {

        // If verification fails, navigate to an error page
        navigate('/error/auth-reset-password', { replace: true })
      }
    }

    verifyOtp()
  }, [location.search, navigate])

  return null
}
